module.exports = __webpack_public_path__ + "static/img/logo82.e2dbd02.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo82.png
// module id = DjiT
// module chunks = 1